// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Yk_iL","name":"Header_name__1biu7","birthday":"Header_birthday__3EfVK","skeleton":"Header_skeleton__DnzYy"};